import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { applyLanguageFilteringSingle } from '@app/common/filtering-behavior';
import { BroadcastsModule } from '@app/components/broadcasts/broadcasts/broadcasts.component';
import { BroadcastMessage } from '@app/models/broadcast-message';
import { LinkModule } from '@app/directives/link.directive';
import { BroadcastService } from '@app/services/broadcast.service';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';
import { UserLanguageTermService } from '@app/services/user-language-term.service';
import { iif, Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

@Component({
  selector: 'app-topnav-broadcasts',
  templateUrl: './topnav-broadcasts.component.html',
  styleUrls: ['./topnav-broadcasts.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TopnavBroadcastsComponent implements OnInit {

  broadcastMessages$: Observable<Array<BroadcastMessage>>;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  constructor(
    private broadcastService: BroadcastService,
    private userLanguageTermService: UserLanguageTermService,
    private featureSettingsStoreService: FeatureSettingsStoreService) { }

  ngOnInit() {
    const broadcastMessages$ =
      this.broadcastService
        .refresh$
        .pipe(
          mergeMap(() => this.broadcastService.getMyHiddenBroadcastMessages())
        );

    this.broadcastMessages$ = broadcastMessages$
      .pipe(
        mergeMap((broadcasts) => {
          // Language filter toggle
          return iif(
            () => this.featureSettingsStoreService.state.enableLanguageFilteringForWorkplace,
            this.userLanguageTermService.getUserLanguageTerms().pipe(
              map((userLanguageTerms) => {
                return applyLanguageFilteringSingle(broadcasts, userLanguageTerms, this.featureSettingsStoreService.state.enableShowNonLanguageContentForAllUsers, this.featureSettingsStoreService.state.defaultLanguageTermId);
              })
            ),
            of(broadcasts)
          );
        }));
  }

  closeMenu() {
    this.trigger.closeMenu();
  }
}
@NgModule({
  declarations: [TopnavBroadcastsComponent],
  exports: [TopnavBroadcastsComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    BroadcastsModule,
    MatButtonModule,
    LinkModule,
  ]
})
export class TopnavBroadcastsModule { }
